module.exports = __webpack_public_path__ + "static/img/chill_out_corner_icon.a91d6c95.png";